export { default } from './PlusLogoBadge';
